import { locations, sortByOptions } from "./constants";
import { formatAbbreviationNumber } from "./formatNumber";
import { fromSearchUrlSlug } from "./formatUrl";
import { PROPERTY_TYPE_MAP } from "./mapping";

export const propertyTypeDetailsList = [
  { id: "TutteLeTipologie", label: "Tutte le tipologie", checked: false },
  { id: "Appartamento", label: "Appartamento", checked: false },
  { id: "AtticoMansarda", label: "Attico - Mansarda", checked: false },
  { id: "CasaIndipendente", label: "Casa indipendente", checked: false },
  { id: "Loft", label: "Loft", checked: false },
  { id: "RusticoCasale", label: "Rustico - Casale", checked: false },
  { id: "Villa", label: "Villa", checked: false },
  { id: "VillettaAschiera", label: "Villetta a schiera", checked: false },
];

export const generateBuyPriceList = () => {
  const numbers = [];
  for (let i = 50000; i < 100000; i += 10000) {
    numbers.push(i);
  }
  for (let i = 100000; i < 400000; i += 20000) {
    numbers.push(i);
  }
  for (let i = 400000; i < 1000000; i += 50000) {
    numbers.push(i);
  }
  for (let i = 1000000; i < 2000000; i += 500000) {
    numbers.push(i);
  }
  for (let i = 2000000; i < 3000000; i += 200000) {
    numbers.push(i);
  }
  for (let i = 3000000; i <= 5000000; i += 500000) {
    numbers.push(i);
  }
  return numbers;
};

export const generateSurfaceOptionList = () => {
  const numbers = [];
  for (let i = 20; i < 200; i += 20) {
    numbers.push(i);
  }
  for (let i = 200; i < 400; i += 50) {
    numbers.push(i);
  }
  for (let i = 400; i <= 1000; i += 100) {
    numbers.push(i);
  }
  return numbers;
};

export const formatFilterText = (min, max, unit) => {
  min = min || "Indifferente";
  max = max || "Indifferente";

  if (min === "Indifferente" && max === "Indifferente") return "";
  if (min === "Indifferente")
    return `fino a ${formatAbbreviationNumber(max)} ${unit}`;
  if (max === "Indifferente")
    return `da ${formatAbbreviationNumber(min)} ${unit}`;
  if (min === max) return `${formatAbbreviationNumber(min)} ${unit}`;
  return `${formatAbbreviationNumber(min)} ${unit} - ${formatAbbreviationNumber(
    max
  )} ${unit}`;
};

export const generateLocalsOptionList = () => {
  const numbers = [];
  for (let i = 1; i <= 5; i += 1) {
    numbers.push(i);
  }

  return numbers;
};

export const formatBathroomText = (bathroom) => {
  if (!bathroom) return "";
  if (bathroom === "4") return "Più di 3 bagni";
  if (parseFloat(bathroom) === 1) return `${bathroom} bagno`;
  return `${bathroom} bagni`;
};

export const floorOptionList = [
  { id: 1, title: "Piano terra" },
  { id: 2, title: "Piani intermedi" },
  { id: 3, title: "Ultimo piano" },
];

export const formatSelectedFloorsText = (floors) => {
  if (floors.length === 0) return "";

  const floorOrderMap = floorOptionList.reduce((acc, floor, index) => {
    acc[floor.id] = index;
    return acc;
  }, {});

  const sortedFloor = floors.sort(
    (a, b) => floorOrderMap[a] - floorOrderMap[b]
  );

  const totalSelected = floors.length;

  // Format the display text
  return totalSelected > 1
    ? `${sortedFloor[0].title} (+${totalSelected - 1})`
    : sortedFloor[0].title;
};

export const formatPropertyType = (
  selectedPropertyType,
  propertyTypeDetails
) => {
  if (
    typeof selectedPropertyType !== "string" ||
    !(selectedPropertyType in PROPERTY_TYPE_MAP)
  ) {
    return [];
  }

  const propertyTypes = PROPERTY_TYPE_MAP[selectedPropertyType];
  return typeof propertyTypes === "function"
    ? propertyTypes(propertyTypeDetails)
    : propertyTypes || [];
};

export const findLocationFromUrl = (locationIds) => {
  const locationIdsAsNumbers = locationIds.map(Number);

  return locations.filter(
    (location) =>
      locationIdsAsNumbers.length > 0 &&
      locationIdsAsNumbers.includes(location.id)
  );
};

export const findSortByOption = (initialSortByValue) => {
  if (!initialSortByValue) return null;
  const decodedValue = fromSearchUrlSlug(initialSortByValue);
  return (
    sortByOptions.find(
      (sort) => sort.label.toLowerCase() === decodedValue.toLowerCase()
    ) || null
  );
};
